/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

var props = {
  align: {
    type: String,
    "default": "left",
    validator: function validator(val) {
      if (!val) return true;
      return ["left", "center", "right"].includes(val);
    }
  },
  allowInputOverMax: Boolean,
  autoWidth: Boolean,
  autocomplete: {
    type: String,
    "default": void 0
  },
  autofocus: Boolean,
  clearable: Boolean,
  disabled: Boolean,
  format: {
    type: Function
  },
  inputClass: {
    type: [String, Object, Array]
  },
  label: {
    type: [String, Function]
  },
  maxcharacter: {
    type: Number
  },
  maxlength: {
    type: Number
  },
  name: {
    type: String,
    "default": ""
  },
  placeholder: {
    type: String,
    "default": void 0
  },
  prefixIcon: {
    type: Function
  },
  readonly: Boolean,
  showClearIconOnEmpty: Boolean,
  showLimitNumber: Boolean,
  size: {
    type: String,
    "default": "medium",
    validator: function validator(val) {
      if (!val) return true;
      return ["small", "medium", "large"].includes(val);
    }
  },
  status: {
    type: String,
    "default": void 0,
    validator: function validator(val) {
      if (!val) return true;
      return ["default", "success", "warning", "error"].includes(val);
    }
  },
  suffix: {
    type: [String, Function]
  },
  suffixIcon: {
    type: Function
  },
  tips: {
    type: [String, Function]
  },
  type: {
    type: String,
    "default": "text",
    validator: function validator(val) {
      if (!val) return true;
      return ["text", "number", "url", "tel", "password", "search", "submit", "hidden"].includes(val);
    }
  },
  value: {
    type: String,
    "default": void 0
  },
  modelValue: {
    type: String,
    "default": void 0
  },
  defaultValue: {
    type: String,
    "default": ""
  },
  onBlur: Function,
  onChange: Function,
  onClear: Function,
  onClick: Function,
  onCompositionend: Function,
  onCompositionstart: Function,
  onEnter: Function,
  onFocus: Function,
  onKeydown: Function,
  onKeypress: Function,
  onKeyup: Function,
  onMouseenter: Function,
  onMouseleave: Function,
  onPaste: Function,
  onValidate: Function,
  onWheel: Function
};

export { props as default };
//# sourceMappingURL=props.mjs.map
